// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3055e9e5","732":"7ab096ea","977":"d3d66595"}[chunkId] + ".chunk.js";
};